/**
 * initMenuFlyOut
 *
 * Initializes the flyout menu functionality for multiple menus.
 *
 * @author Co-Pilot, matt.breiwick
 */
export default function initMenuFlyOut() {
    // Select all flyout menu buttons and menus by a common class
    const btns = document.querySelectorAll('[data-flyout-menu-btn]');
    const menus = document.querySelectorAll('[data-flyout-menu]');
    const closeBtns = document.querySelectorAll('[data-close-flyout-menu]');

    function isModalOpen() {
        const microModal = document.querySelector('.micromodal-slide.is-open');
        if (microModal) return true;
        const lightbox = document.getElementById('gf-lightbox');
        if (lightbox && !lightbox.classList.contains('is-hidden')) return true;
        const anyModal = document.querySelector('[role="dialog"][aria-hidden="false"]');
        if (anyModal) return true;
        return false;
    }

    // Each menu gets its own open/close logic and outside click handler
    btns.forEach((btn, i) => {
        const menu = menus[i];
        const closeBtn = closeBtns[i];

        if (!btn || !menu || !closeBtn) return;

        function openMenu() {
            menu.setAttribute('aria-expanded', 'true');
            btn.setAttribute('aria-expanded', 'true');
            menu.focus();

            setTimeout(() => {
                document.addEventListener('pointerdown', handleOutsideClick, { capture: true });
            }, 0);
        }

        function closeMenu() {
            menu.setAttribute('aria-expanded', 'false');
            btn.setAttribute('aria-expanded', 'false');
            btn.focus();

            document.removeEventListener('pointerdown', handleOutsideClick, { capture: true });
        }

        function handleOutsideClick(e) {
            if (isModalOpen()) return;
            if (!menu.contains(e.target) && !btn.contains(e.target)) {
                closeMenu();
            }
        }

        btn.addEventListener('click', openMenu);
        closeBtn.addEventListener('click', closeMenu);
        menu.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                if (isModalOpen()) return;
                closeMenu();
            }
        });
    });
}
